import styled from 'styled-components';
import { Icon, Typography } from '../../../../../stories/atoms';

export const StyledIcon = styled(Icon)`
  width: ${({ theme: { spacing } }) => spacing(3)};
  height: ${({ theme: { spacing } }) => spacing(3)};
`;

export const StyledChartIcon = styled(StyledIcon)`
  position: absolute;
  top: ${({ theme: { spacing } }) => spacing(1)};
  right: ${({ theme: { spacing } }) => spacing(1)};
`;

export const StyledChartTypography = styled(Typography)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
`;
